import React, { useContext } from "react";
import { RicosContext } from "./../ricos-context/index.js";
import { ActionBar } from "./../ui-components/action-bar/action-bar.js";
import { ListItemSelect } from "./list-item-select/list-item-select.js";
const SelectableOptionsList = ({ options, selectedId, onChange }) => {
  const { t, isMobile, environment } = useContext(RicosContext);
  return environment === "wixel" ? /* @__PURE__ */ React.createElement(
    ActionBar,
    {
      options: options.map(({ value, wixelIcon: WixelIcon }) => ({
        id: value,
        icon: /* @__PURE__ */ React.createElement(WixelIcon, null)
      })),
      selectedId,
      onChange: (value) => {
        onChange(value);
      }
    }
  ) : options.map(({ icon: Icon, mobileIcon: MobileIcon, value, dataHook, text }) => /* @__PURE__ */ React.createElement(
    ListItemSelect,
    {
      key: value,
      dataHook,
      prefix: isMobile ? /* @__PURE__ */ React.createElement(MobileIcon, null) : /* @__PURE__ */ React.createElement(Icon, null),
      title: t(text),
      selected: value === selectedId,
      onSelect: () => onChange(value)
    }
  ));
};
export {
  SelectableOptionsList
};
//# sourceMappingURL=selectable-options-list.js.map
